import { featuresData } from '@/mocks/home';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">平台优势</h2>
          <p className="text-foreground-600 text-sm md:text-base">为什么选择今日吃瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((feature) => (
            <div
              key={feature.id}
              className="p-6 md:p-7 rounded-xl bg-background-50 border border-background-200/70 text-center group hover:border-primary-200 transition-colors"
            >
              <span className="w-14 h-14 md:w-16 md:h-16 flex items-center justify-center rounded-2xl bg-primary-100 text-primary-600 mx-auto mb-5 group-hover:bg-primary-500 group-hover:text-white transition-colors">
                <i className={`${feature.icon} text-2xl`}></i>
              </span>
              <h3 className="text-base md:text-lg font-semibold text-foreground-900 mb-3">{feature.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed">{feature.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}